import "./ClientRiskRowComponent.scss";
import {ClientRiskRow as RiskRow} from "../../../models/risk-model/RiskSummary";
import {RiskService} from "../../../service/RiskService";

export const ClientRiskRow = "clientRiskRow";

export function clientRiskRow() {
    return {
        templateUrl: "app/risk/dashboard/components/grid/client/ClientRiskRowComponent.html",
        bindings: {
            client: "<",
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: ClientRiskRowComponentController
    };
}

export class ClientRiskRowComponentController {

    public readonly client: RiskRow;

    /** @ngInject */
    constructor(private riskService: RiskService) {
    }

    public saveChange(detail: RiskRow) {
        this.riskService.updatePortfolioRiskLimits(detail.id, detail);
    }
}
